var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publishing"},[_c('top-nav'),(this.$route.name == 'discussions')?_c('discussion-search'):_vm._e(),(this.$route.name == 'asset_assignments')?_c('assignment-search'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }